import React, { useContext, useEffect, useState } from "react";
// import TableData from "../component/TableData";
import { AuthContext } from "../auth/ContextAuthentication";
import useAxiosConfig from "../config/AxiosConfig";
import PaymentTable from "../component/PaymentTable";
import { TextField, Button } from "@mui/material";
const headerData = [
  "Name",
  "Type",
  "Amount",
  "Payment Type",
  "Wallet Balance",
  "Phone Number",
  "Transaction Date",
  "Match Date",
  "Match Time",
];

const PaymentVerfication = () => {
  const axiosInstance = useAxiosConfig();
  const { setPaymentTransactions } = useContext(AuthContext);
  const { setPaymentPagination } = useContext(AuthContext);
  const [datafetched, setDataFetched] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchName, setSearchName] = useState("");
  const [searchPhone, setSearchPhone] = useState("");


  useEffect(() => {
    const fetchApi = async () => {
      try {
        const params = new URLSearchParams();
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);
        if (searchName.trim()) params.append("name", searchName.trim());
        if (searchPhone.trim()) params.append("phone", searchPhone.trim());

        const response = await axiosInstance.get(
          `api/admin/payments/get-all-transactions?${params.toString()}`
        );

        setPaymentTransactions(response.data.transactions);
        const { currentPage, totalPages } = response.data;

        setPaymentPagination({
          currentPage: currentPage,
          totalPages: totalPages,
        });
        setDataFetched(true);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchApi();
  }, [setPaymentTransactions, setPaymentPagination, startDate, endDate, searchName, searchPhone]);

  const handleResetFilters = () => {
    setStartDate("");
    setEndDate("");
    setSearchName("");
    setSearchPhone("");
  };

  return (
    <>
      {/* <TableData headerData={headerData} /> */}

      <h2 className="text-xl font-bold mb-4">Payment Verification</h2>
      <div className="flex flex-wrap gap-5 mb-4 items-center">
        <TextField
          label="Name"
          type="text"
          size="small"
          placeholder="Search by name"
          sx={{ maxWidth: "250px" }}
          value={searchName}
          onChange={(e) => setSearchName(e.target.value)}
          style={{ width: 200 }}
        />
        <TextField
          label="Phone Number"
          type="text"
          size="small"
          placeholder="Search by phone"
          sx={{ maxWidth: "250px" }}
          value={searchPhone}
          onChange={(e) => setSearchPhone(e.target.value)}
          style={{ width: 200 }}
        />
        <TextField
          label="Start Date"
          type="date"
          size="small"
          sx={{ maxWidth: "250px" }}
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          style={{ width: 200 }}
        />
        <TextField
          label="End Date"
          type="date"
          size="small"
          sx={{ maxWidth: "250px" }}
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          style={{ width: 200 }}
        />
        <Button
          variant="contained"
          color="success"
          onClick={handleResetFilters}
        >
          <span className="text-white">Reset Filter</span>
        </Button>
      </div>
      {datafetched && (
        <PaymentTable
          headerData={headerData}
          filterParams={{ startDate, endDate, name: searchName.trim(), phone: searchPhone.trim() }}
        />
      )}
    </>
  );
};

export default PaymentVerfication;
